import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KnownIpAddressApiService } from './known-ip-address.api.service';
import { KnownIpAddressEffects } from './known-ip-address.effects';
import {
  knownIpAddressReducer,
  knownIpAddressInitialState,
  IKnownIpAddressState,
} from './known-ip-address.reducer';
import { KnownIpAddressService } from './known-ip-address.service';
import { knownIpAddressFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IKnownIpAddressState>(
      knownIpAddressFeatureKey,
      knownIpAddressReducer,
      {
        initialState: knownIpAddressInitialState,
      },
    ),
    EffectsModule.forFeature([KnownIpAddressEffects]),
  ],
  providers: [KnownIpAddressApiService, KnownIpAddressService],
})
export class StoreKnownIpAddressModule {}
